// extracted by mini-css-extract-plugin
module.exports = {"container":"pgLEuL","resultContainer":"Jj5ulj"};